/* eslint-disable jsx-a11y/anchor-is-valid */
import downArrow from "assets/pictures/arrow-down.svg";
import cancelImg from "assets/pictures/Cancel-icon.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import BrandQuery from "./BrandQuery";
import SizeQuery from "./SizeQuery";
import PriceSlider from "./RangeSlider";
import CategoryQuery from "./CategoryQuery";


const OffcanvasFilter = ({ shop_id, category }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { brands = [] } = BrandQuery(shop_id); // Default to empty array
  const { categories = [] } = CategoryQuery(shop_id);
  const { sizes = [] } = SizeQuery();

  // State to manage visibility of each filter section
  const [isCategoriesOpen, setIsCategoriesOpen] = useState(true);
  const [isBrandsOpen, setIsBrandsOpen] = useState(true);
  const [isPriceOpen, setIsPriceOpen] = useState(true);
  const [isSizeOpen, setIsSizeOpen] = useState(true);

  // State to manage selected filter values
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedSizes, setSelectedSizes] = useState([]);

  // Initialize selected filters from URL on component mount
  useEffect(() => {
    const categoriesFromUrl = searchParams.get("category")
      ? searchParams.get("category").split(",")
      : [];
    const brandsFromUrl = searchParams.get("brand")
      ? searchParams.get("brand").split(",")
      : [];
    const sizesFromUrl = searchParams.get("size")
      ? searchParams.get("size").split(",")
      : [];

    setSelectedCategories(categoriesFromUrl);
    setSelectedBrands(brandsFromUrl);
    setSelectedSizes(sizesFromUrl);
  }, [searchParams]);

  const handleFilterChange = (key, value, selectedValues, setSelectedValues) => {
    let updatedValues;
    if (selectedValues.includes(value)) {
      updatedValues = selectedValues.filter((val) => val !== value);
    } else {
      updatedValues = [...selectedValues, value];
    }
    setSelectedValues(updatedValues);

    // Update URL with all filters
    const params = {};
    for (const [paramKey, paramValue] of searchParams) {
      if (paramKey === "price") {
        const [min, max] = paramValue.split(",");
        Object.assign(params, { price_min: min, price_max: max });
      } else {
        Object.assign(params, { [paramKey]: paramValue });
      }
    }

    // Update the specific filter key with the new array of values
    if (updatedValues.length > 0) {
      Object.assign(params, { [key]: updatedValues.join(",") });
    } else {
      delete params[key]; // Remove the key if no values are selected
    }

    const query = new URLSearchParams(params).toString();
    navigate(`/products?${query}`);
  };

  const clearFilter = () => {
    navigate("/products");
  };

  return (
    <div
      className="offcanvas offcanvas-end"
      tabIndex="-1"
      id="filterOffcanvas"
      aria-labelledby="filterOffcanvasLabel"
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title" id="filterOffcanvasLabel">
          Filter Products
        </h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body">
        <div className="category-filter">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <button onClick={clearFilter} className="btn btn-dark">
              Clear Filter
            </button>
            <img src={cancelImg} alt="Cancel" className="cancel-icon" />
          </div>

          {/* Categories Filter */}
          <div className="filter-section">
            <div
              className="cathead-wrapper d-flex justify-content-between align-items-center"
              onClick={() => setIsCategoriesOpen(!isCategoriesOpen)}
            >
              <p className="cathead mb-0">Categories</p>
              <img
                src={downArrow}
                alt="Toggle"
                className={`toggle-arrow ${isCategoriesOpen ? "open" : ""}`}
              />
            </div>
            {isCategoriesOpen && (
            <ul className="nav flex-column mt-3">
              {categories.map((category) => (
                <li className="cat-filt" key={category.id}>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={category.id}
                      checked={selectedCategories.includes(category.id.toString())}
                      onChange={() =>
                        handleFilterChange(
                          "category",
                          category.id.toString(),
                          selectedCategories,
                          setSelectedCategories
                        )
                      }
                      id={`category_${category.id}`}
                    />
                    <label
                      htmlFor={`category_${category.id}`}
                      className="form-check-label category-item"
                    >
                      {category.name}
                    </label>
                  </div>
                </li>
              ))}
            </ul>
          )}
          </div>

          {/* Brands Filter */}
          <div className="filter-section brands-filter">
            <div
              className="cathead-wrapper d-flex justify-content-between align-items-center"
              onClick={() => setIsBrandsOpen(!isBrandsOpen)}
            >
              <p className="cathead mb-0">Brands</p>
              <img
                src={downArrow}
                alt="Toggle"
                className={`toggle-arrow ${isBrandsOpen ? "open" : ""}`}
              />
            </div>
            {isBrandsOpen && brands.length > 0 && (
            <div className="scroll-div mt-3">
              <ul className="list-group">
                {brands.map((brand) => (
                  <li className="list-group-item" key={brand.id}>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value={brand.id}
                        checked={selectedBrands.includes(brand.id.toString())}
                        onChange={() =>
                          handleFilterChange(
                            "brand",
                            brand.id.toString(),
                            selectedBrands,
                            setSelectedBrands
                          )
                        }
                        id={`brand_${brand.id}`}
                      />
                      <label
                        htmlFor={`brand_${brand.id}`}
                        className="form-check-label brand-label"
                      >
                        {brand.name}
                      </label>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}
          </div>

          {/* Price Filter */}
          <div className="filter-section price-filter">
            <div
              className="cathead-wrapper d-flex justify-content-between align-items-center"
              onClick={() => setIsPriceOpen(!isPriceOpen)}
            >
              <p className="cathead mb-0">Price</p>
              <img
                src={downArrow}
                alt="Toggle"
                className={`toggle-arrow ${isPriceOpen ? "open" : ""}`}
              />
            </div>
            {isPriceOpen && (
              <div className="mt-3">
                <PriceSlider />
              </div>
            )}
          </div>

          {/* Size Filter */}
          <div className="filter-section size-filter">
            <div
              className="cathead-wrapper d-flex justify-content-between align-items-center"
              onClick={() => setIsSizeOpen(!isSizeOpen)}
            >
              <p className="cathead mb-0">Size</p>
              <img
                src={downArrow}
                alt="Toggle"
                className={`toggle-arrow ${isSizeOpen ? "open" : ""}`}
              />
            </div>
            {isSizeOpen && sizes.length > 0 && (
              <div className="scroll-div mt-3">
                <ul className="list-group">
                  {sizes.map((size, idx) => (
                    <li className="list-group-item" key={size?.id || idx}>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value={size?.id}
                          checked={selectedSizes.includes(size?.id?.toString())}
                          onChange={() =>
                            handleFilterChange(
                              "size",
                              size?.id?.toString(),
                              selectedSizes,
                              setSelectedSizes
                            )
                          }
                          id={`size_${size?.id || idx}`}
                        />
                        <label
                          htmlFor={`size_${size?.id || idx}`}
                          className="form-check-label size-label"
                        >
                          {size?.name || "Unknown Size"}
                        </label>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OffcanvasFilter;